import { render } from "./links.vue?vue&type=template&id=4e56938f"
import script from "./links.vue?vue&type=script&lang=js"
export * from "./links.vue?vue&type=script&lang=js"

import "./links.vue?vue&type=style&index=0&id=4e56938f&lang=scss"
/* custom blocks */
import block0 from "./links.vue?vue&type=custom&index=0&blockType=i18n&lang=json5"
if (typeof block0 === 'function') block0(script)
import block1 from "./links.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__